import { render, staticRenderFns } from "./DomesticLogistics.vue?vue&type=template&id=2936c26a&scoped=true"
import script from "./DomesticLogistics.vue?vue&type=script&lang=js"
export * from "./DomesticLogistics.vue?vue&type=script&lang=js"
import style0 from "./DomesticLogistics.vue?vue&type=style&index=0&id=2936c26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2936c26a",
  null
  
)

export default component.exports